import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, Router } from '@angular/router';
import { UserService } from '../pages/user.service';
import { AuthService } from './auth.service';
import { CookieService } from './cookies';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  loggedIn : boolean = false;
  constructor( private router : Router, private cookies : CookieService){}
  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean{
    let userId = localStorage.getItem('currentUser');
    if(userId!= null){
        this.loggedIn = true;
    }else{
        this.loggedIn = false;
    }
    return this.loggedIn;
    //return true;
  }

}
